/**
 * AIメンター系画面のルート定義。
 *
 * ダッシュボード4画面（面接練習・適性検査・自己分析・キャリア相談）は
 * 相互に行き来するので同じ `ai-chat` チャンクへまとめる。
 * `router.js` から `...aiRoutes(SITE_TITLE)` で展開する。
 */

import type { RouteConfig } from 'vue-router'

export function aiRoutes(siteTitle: string): RouteConfig[] {
  return [
    {
      path: '/ai/interview_start',
      component: () => import('@/views/pages/ai/InterviewStart.vue'),
      props: true,
      name: 'interviewStart',
      meta: {
        title: `AI面接練習(β版)のリスト - ${siteTitle}`,
        linkformat: 6
      }
    },
    {
      path: '/ai/interview_practice',
      component: () =>
        import(
          /* webpackChunkName: "ai-chat" */ '@/views/pages/ai/InterviewChat.vue'
        ),
      props: true,
      name: 'interviewChat',
      meta: {
        title: `AI面接練習(β版) - ${siteTitle}`,
        linkformat: 6
      }
    },
    {
      path: '/ai/voice_interview_practice',
      component: () => import('@/views/pages/ai/VoiceInterviewChat.vue'),
      props: true,
      name: 'voiceInterviewChat',
      meta: {
        title: `音声でAI面接練習(β版) - ${siteTitle}`,
        linkformat: 6
      }
    },
    {
      path: '/ai/aptitude_practice',
      component: () =>
        import(
          /* webpackChunkName: "ai-chat" */ '@/views/pages/ai/AptitudeChat.vue'
        ),
      props: true,
      name: 'aptitudeChat',
      meta: {
        title: `適性検査練習(β版) - ${siteTitle}`,
        linkformat: 6
      }
    },
    {
      path: '/ai/self_analysis',
      component: () =>
        import(
          /* webpackChunkName: "ai-chat" */ '@/views/pages/ai/SelfAnalysisChat.vue'
        ),
      props: true,
      name: 'selfAnalysisChat',
      meta: {
        title: `自己分析(β版) - ${siteTitle}`,
        linkformat: 6
      }
    },
    {
      path: '/ai/career',
      component: () =>
        import(
          /* webpackChunkName: "ai-chat" */ '@/views/pages/ai/CareerChat.vue'
        ),
      props: true,
      name: 'careerChat',
      meta: {
        title: `AIキャリア相談(β版) - ${siteTitle}`,
        linkformat: 6
      }
    }
  ]
}
